import { useContext, useEffect, type FC } from "react";

import clsx from "clsx";

import heroBackground from "@assets/mmm/hero-bg.svg";
import { PrimaryButton } from "@shared/buttons";

import { SideNavContext } from "..";

import { type StepChildProps } from "./step";
import { StepContainer } from "./step-container";

export const Finish: FC<StepChildProps> = (props) => {
  const { setSubNavItems } = useContext(SideNavContext);

  useEffect(() => {
    setSubNavItems([]);
  }, [setSubNavItems]);
  return (
    <StepContainer isLast={true} knowledgeBaseLink="" knowledgeBaseText="">
      <div className=" h-full overflow-hidden">
        <div
          className={clsx(
            "bg-interstellar relative flex-col rounded-lg mx-6 mt-6  h-[calc(100%-56px)] overflow-scroll pt-12 pb-8 px-16 text-white",
            "flex items-center justify-start gap-8 bg-right-bottom bg-no-repeat",
          )}
          style={{ backgroundImage: `url(${heroBackground})` }}
        >
          <div className="flex flex-col">
            <div className="max-w-[1200px] flex flex-col items-center">
              <h1 className="text-[42px] leading-[56px] mb-7 mt-2 text-center">
                That's all for now!
              </h1>
              <div className="py-6">
                <DoneIcon />
              </div>
              <p className="text-2xl font-normal leading-8 max-w-[1200px] text-center">
                Next, the Northbeam Team will work to complete your
                configuration, including validation of your connections and
                data. Our team will be in touch with any steps necessary to
                complete your setup and validation.
              </p>
            </div>
          </div>
          <div className="w-full flex justify-center items-center gap-2 h-[90px] py-6">
            <div className="font-semibold text-2xl flex items-center justify-center">
              Any questions? We can help!
            </div>
            <PrimaryButton
              onClick={() => {
                // eslint-disable-next-line no-restricted-globals
                location.href = "mailto:success@northbeam.io";
              }}
              className="uppercase text-xl rounded-full flex gap-2 items-center justify-center"
            >
              <i className="fa-light fa-envelope"></i>
              EMAIL US
            </PrimaryButton>
          </div>
        </div>
      </div>
    </StepContainer>
  );
};

function DoneIcon() {
  return (
    <svg
      width="203"
      height="204"
      viewBox="0 0 203 204"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 51964">
        <g id="Group 51949">
          <g id="Group 51930">
            <g id="Group 51929">
              <g id="Group 49690">
                <g id="Group 49488">
                  <rect
                    id="Rectangle 5993"
                    x="1.08948"
                    y="0.25"
                    width="200.821"
                    height="202.685"
                    rx="100.411"
                    stroke="#BCFBBA"
                    strokeWidth="0.5"
                  />
                  <g id="Rectangle 5992">
                    <g filter="url(#filter0_i_2204_60133)">
                      <rect
                        x="0.839478"
                        width="201.321"
                        height="203.185"
                        rx="100.661"
                        fill="#021330"
                      />
                    </g>
                    <rect
                      x="1.33948"
                      y="0.5"
                      width="200.321"
                      height="202.185"
                      rx="100.161"
                      stroke="#BCFBBA"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <path
          id="check"
          d="M143.5 79.8357L139.449
          83.8405L94.3605 128.417L90.4857
          132.422L86.4348 128.417L63.8904 106.129L59.8395 102.124L67.9413 94.2881L71.8162
           98.293L90.4857 116.576L131.523 76.0049L135.574 72L143.5 79.8357Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_i_2204_60133"
          x="0.839478"
          y="0"
          width="201.321"
          height="203.186"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect1_innerShadow_2204_60133"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="12.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.678431 0 0 0 0 0.87451 0 0 0 0 0.694118 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_2204_60133"
          />
        </filter>
      </defs>
    </svg>
  );
}
